'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthRemote = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthRemote = exports.AuthRemote = {
    postAddCreditCard: function postAddCreditCard(_ref) {
        var authToken = _ref.authToken,
            bidderId = _ref.bidderId,
            cardToken = _ref.cardToken,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({
                authToken: authToken,
                deployment: deployment,
                path: '<MAINHOST-API>api/bidders/' + bidderId + '/stripe/customer'
            });
            request.send({ card_token: cardToken });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postConfirmPassword: function postConfirmPassword(_ref2) {
        var deployment = _ref2.deployment,
            password = _ref2.password,
            username = _ref2.username;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ deployment: deployment, path: '<ITEM-API>auth/spalogin' });
            request.send({ password: password, username: username });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postForgotPassword: function postForgotPassword(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            emailAddress = _ref3.emailAddress;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({
                authToken: authToken,
                deployment: deployment,
                path: '<MAINHOST-API>api/pw_reset',
                queryParams: { client_version: '4.3' }
            });

            var _emailAddress$split = emailAddress.split('@'),
                _emailAddress$split2 = (0, _slicedToArray3.default)(_emailAddress$split, 2),
                username = _emailAddress$split2[0],
                domain = _emailAddress$split2[1];

            request.type('form');
            request.send({ email: username.replace('+', '%2B') + '@' + domain }); // To allow emails with pluses
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postPayment: function postPayment(_ref4) {
        var shipping_address = _ref4.address,
            amount = _ref4.amount,
            authToken = _ref4.authToken,
            bidderId = _ref4.bidderId,
            card_token = _ref4.cardToken,
            catalogId = _ref4.catalogId,
            currency = _ref4.currency,
            deployment = _ref4.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({
                authToken: authToken,
                deployment: deployment,
                path: '<MAINHOST-API>api/bidders/' + bidderId + '/wonitems/catalogs/' + catalogId + '/payments'
            });
            request.send({ amount: amount, card_token: card_token, currency: currency, shipping_address: shipping_address });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postResetPassword: function postResetPassword(_ref5) {
        var bidderId = _ref5.bidderId,
            deployment = _ref5.deployment,
            hash = _ref5.hash,
            newPassword = _ref5.newPassword;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ deployment: deployment, path: '<ITEM-API>auth/spa/reset-password' });
            request.send({ bidderId: bidderId, hash: hash, newPassword: newPassword });
            request.end(function (err, response) {
                return (0, _helpers.handleResponseUseItemApiError)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postUpdatePassword: function postUpdatePassword(_ref6) {
        var authToken = _ref6.authToken,
            deployment = _ref6.deployment,
            newPassword = _ref6.newPassword,
            oldPassword = _ref6.oldPassword;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>auth/update-password' });
            request.send({ newPassword: newPassword, oldPassword: oldPassword });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    putAddCreditCard: function putAddCreditCard(_ref7) {
        var authToken = _ref7.authToken,
            bidderId = _ref7.bidderId,
            cardToken = _ref7.cardToken,
            deployment = _ref7.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePut)({
                authToken: authToken,
                deployment: deployment,
                path: '<MAINHOST-API>api/bidders/' + bidderId + '/stripe/customer'
            });
            request.send({ card_token: cardToken });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/auth.js
// module id = i2pf
// module chunks = 60